import styled from 'styled-components';

export const Container = styled.div`
  form {
    width: 100%;

    .buttonsContainer {
      display: flex;
      justify-content: flex-end;
    }
  }
`;
